/* eslint-disable */
import commentTemplate from './comment.phtml';
import CommentsRepository from "@/js/common/Domain/Repository/Comments";
import requestService from "@/js/common/Domain/Service/request";
import gaAsync from "@/js/common/Domain/Service/gaAsync";
import CommentFactory from "@/js/common/Domain/Factory/Comment";

var commentView = Backbone.Epoxy.View.extend({
    el: '<div itemprop="review" itemscope itemtype="http://schema.org/Review" class="hotelReview"></div>',
    template:commentTemplate,
    initialize: function() {
        var model = this.model.toJSON({computed: true});
        this.$el.html(this.template(model));
        this.$el.find('.reviewReadMore, .reviewReadLess').on('click', function() {
            var $container = $(this).parent();
            $container.find('.hotelReviewFullText').toggle();
            $container.find('.hotelReviewText').toggle();
            $container.find('.reviewReadMore, .reviewReadLess').toggleClass('show');
        });
    }
});

var CommentsModel = Backbone.Epoxy.Model.extend({
    defaults: {
        commentsByLimit: null,
        pageNumber: 1,
        showAddCommentForm: false,
        clearData: false,
        loadingState: "loading" //"loading", "finished"
    },
    computeds: {
        countNextComments: function() {
            const commentsByLimit = this.get('commentsByLimit');
            const limit = this.get('limit');
            return commentsByLimit - limit;
        },
        viewButtonNextComments: function() {
            const commentsByLimit = this.get('commentsByLimit');
            const limit = this.get('limit');
            return (commentsByLimit <= limit) ? false : true;
        },
        nextCommentsText: function() {
            const nextComments = this.get('countNextComments');
            if(nextComments) {
                return nextComments + ' отзыв' + nextComments.wordEnding(';а;ов');
            }
        }
    },
    initialize:function() {
        this.set({
            limit: typeof numOfCommentsOnPage != "undefined" ? numOfCommentsOnPage : 10,
            hotelId: window.appConfig.hotelInfo.id,
        });
    }
});

let StaticCommentsView = Backbone.Epoxy.View.extend({
    collection: new CommentsRepository(),
    itemView: commentView,
    bindings: {
        ".hotelReviewsWrapper": "classes:{changeSort: clearData}",
        "#commentTemplate": "collection:$collection",
        ".hotelReviewsWrapperStatic":'toggle:false',
        '.hotelReviewsTopPanel': "toggle:commentsByLimit",
        '.hotelReviewsNoComments': "toggle:all(not(commentsByLimit), equal(loadingState, 'finished'))",
        '.js-open-review-form': "toggle:all(commentsByLimit, equal(loadingState, 'finished'))",
        ".hotelMoreReviewsButton": "toggle:all(viewButtonNextComments, not(equal(loadingState, 'loading'))), event:['click', 'nextPage']",
        ".hotelMoreReviewsButton span": "text:nextCommentsText",
        ".openReviewForm": "toggle:not(showAddCommentForm), event:['click', 'toggleCommentForm']",
        ".closeReviewForm": "toggle:showAddCommentForm, event:['click', 'toggleCommentForm']",
        ".loading": "toggle: equal(loadingState, 'loading')",
        '.addReview': 'animatedToggle:showAddCommentForm'
    },
    initialize: function() {
        var self = this;

        this.model = new CommentsModel();
        this.comments = [];

        this.initEvents();
    },
    toggleCommentForm: function() {
        var showAddCommentForm = this.model.get('showAddCommentForm');
        this.model.set('showAddCommentForm', !showAddCommentForm);

        if(!showAddCommentForm) {
            gaAsync(function() {
                ga('send', 'event', 'Buttons', 'Add_a_review', window.appConfig.hotelInfo.name, {'nonInteraction': 1})
            });
        }
    },
    nextPage: function() {
        var viewButtonNextComments = this.model.get('viewButtonNextComments'),
                currentPage = this.model.get('pageNumber');

        if(viewButtonNextComments) {
            this.model.set('pageNumber', currentPage + 1);
        }

        gaAsync(function() {
            ga('send', 'event', 'Buttons', 'Show_more_reviews', window.appConfig.hotelInfo.name, {'nonInteraction': 1})
        });
    },
    clearAndLoad: async function() {
        this.clearData();
        await this.loadData();
    },
    clearData: function() {
        this.model.set('clearData', true);
        this.model.set('pageNumber', 1);
    },
    loadData: function() {
        return new Promise((res, rej) => {
            const hotel = this.model.get('hotelId');
            const limit = this.model.get('limit');
            const numberPage = this.model.get('pageNumber');
            const clearData = this.model.get('clearData');
            const offset = limit * numberPage - limit;
            const counNextReviews = limit * 2;
            const data = {
                limit: counNextReviews,
                offset,
            }
            const self = this;
            this.model.set('loadingState', 'loading');
            requestService({
                url: `${window.appConfig.apiGateWay}/frontend/directory/hotels/${hotel}/reviews`,
                data,
                dataType: "json"
            }, {
                success: function(response) {
                    const staticCommentsCollection = response?.result;
                    let comments = [];

                    _.each(staticCommentsCollection, function(feedback) {
                        if(!feedback.text) {
                            feedback.text = 'Пользователь поставил только оценку, без текста';
                        }
                        comments.push(new CommentFactory(feedback));
                    })
                    self.model.set('commentsByLimit', comments.length);
                    comments = comments.slice(0, limit);

                    if (clearData) {
                        self.collection.reset(comments);
                    } else {
                        self.collection.add(comments);
                    }
                    self.model.set('loadingState', 'finished');
                    self.model.set('clearData', false);
                    res();
                }
            })
        })
    },
    async initEvents() {
        this.model.on('change:pageNumber', this.loadData.bind(this));
    }
});

export default StaticCommentsView;
